import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'

export interface TypeButtonBlockFields {
  title: EntryFieldTypes.Symbol
  href: EntryFieldTypes.Symbol
  target?: EntryFieldTypes.Symbol<'App' | 'Tab'>
}

export type TypeButtonBlockSkeleton = EntrySkeletonType<TypeButtonBlockFields, 'buttonBlock'>
export type TypeButtonBlock<Modifiers extends ChainModifiers, Locales extends LocaleCode> = Entry<
  TypeButtonBlockSkeleton,
  Modifiers,
  Locales
>

export function isTypeButtonBlock<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeButtonBlock<Modifiers, Locales> {
  return entry.sys.contentType.sys.id === 'buttonBlock'
}
